import { render, staticRenderFns } from "./PainAssessmentInPediatricPatients.vue?vue&type=template&id=e510ed44&scoped=true"
import script from "./PainAssessmentInPediatricPatients.vue?vue&type=script&lang=js"
export * from "./PainAssessmentInPediatricPatients.vue?vue&type=script&lang=js"
import style0 from "./PainAssessmentInPediatricPatients.vue?vue&type=style&index=0&id=e510ed44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e510ed44",
  null
  
)

export default component.exports